import useCooperationHooks from './hooks'
import { Row, Col, Modal, Space, Button, Form, Input } from 'antd'
import styles from './style.module.scss'
import OrderInfo from './OrderInfo'
import CustomTable from '../../components/CustomTable'
const Cooperation = () => {
  const {
    visible,
    hideModal,
    form,
    okModal,
    infoObj,
    orderType,
    confirmGoods,
  } = useCooperationHooks()

  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const itemLayou = {
    style: {
      marginBottom: '10px',
      marginLeft: '30px',
    },
  }
  const returnlistColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'productCode',
      dataIndex: 'productCode',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'productName',
      dataIndex: 'productName',
      title: '商品名称',
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '型号',
    },
    {
      key: 'returnQty',
      dataIndex: 'returnQty',
      title: '退货数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'productPrice',
      dataIndex: 'productPrice',
      title: '单价',
    },
  ]
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'productCode',
      dataIndex: 'productCode',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'productName',
      dataIndex: 'productName',
      title: '商品名称',
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '型号',
    },
    {
      key: 'cancelQty',
      dataIndex: 'cancelQty',
      title: '取消数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'productPrice',
      dataIndex: 'productPrice',
      title: '单价',
    },
  ]
  return (
    <div style={{ padding: '0 20px' }}>
      <OrderInfo infoObj={infoObj} />
      {orderType === 'returnorder' && (
        <div
          className={styles.tablehead}
          style={
            infoObj.state === '5'
              ? { background: 'rgb(40, 129, 255)' }
              : { background: 'rgb(3, 134, 64)' }
          }
        >
          <Row justify="space-between">
            <Col span={20}>
              <Space size={'large'}>
                <div>退货单编号：{infoObj?.returnNumber}</div>
                <div>退货时间：{infoObj?.returnTime}</div>
                <div>退货金额：{infoObj?.returnPrice}</div>
                <div>状态：{infoObj?.stateToName}</div>
              </Space>
            </Col>
            <Col span={2}>
              {infoObj.state === '5' ? (
                <Button onClick={confirmGoods}>确认收货</Button>
              ) : null}
            </Col>
          </Row>
        </div>
      )}
      <CustomTable
        dataSource={
          orderType === 'returnorder'
            ? infoObj?.returnProductDTOList
            : infoObj?.cancelProductDTOList
        }
        isLoading={false}
        columns={orderType === 'returnorder' ? returnlistColumn : listColumn}
      ></CustomTable>
      <Modal
        title="提示"
        width={450}
        open={visible}
        onOk={okModal}
        onCancel={hideModal}
        okText="确定"
        cancelText="取消"
      >
        <Form form={form}>
          <Form.Item
            label="原因"
            name="reason"
            rules={[
              { required: true, whitespace: true, message: '请输入理由' },
            ]}
            {...itemLayou}
          >
            <Input.TextArea autoComplete="off" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default Cooperation
import useCooperationHooks from './hooks'
import { Row, Col, Modal, Space, Button, Form, Input } from 'antd'
import styles from './style.module.scss'
import OrderInfo from './OrderInfo'
import CustomTable from '../../components/CustomTable'
const Cooperation = () => {
  const {
    visible,
    hideModal,
    form,
    okModal,
    infoObj,
    orderType,
    confirmGoods,
  } = useCooperationHooks()

  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const itemLayou = {
    style: {
      marginBottom: '10px',
      marginLeft: '30px',
    },
  }
  const returnlistColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'productCode',
      dataIndex: 'productCode',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'productName',
      dataIndex: 'productName',
      title: '商品名称',
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '型号',
    },
    {
      key: 'returnQty',
      dataIndex: 'returnQty',
      title: '退货数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'productPrice',
      dataIndex: 'productPrice',
      title: '单价',
    },
  ]
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'productCode',
      dataIndex: 'productCode',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'productName',
      dataIndex: 'productName',
      title: '商品名称',
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '型号',
    },
    {
      key: 'cancelQty',
      dataIndex: 'cancelQty',
      title: '取消数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'productPrice',
      dataIndex: 'productPrice',
      title: '单价',
    },
  ]
  return (
    <div style={{ padding: '0 20px' }}>
      <OrderInfo infoObj={infoObj} />
      {orderType === 'returnorder' && (
        <div
          className={styles.tablehead}
          style={
            infoObj.state === '5'
              ? { background: 'rgb(40, 129, 255)' }
              : { background: 'rgb(3, 134, 64)' }
          }
        >
          <Row justify="space-between">
            <Col span={20}>
              <Space size={'large'}>
                <div>退货单编号：{infoObj?.returnNumber}</div>
                <div>退货时间：{infoObj?.returnTime}</div>
                <div>退货金额：{infoObj?.returnPrice}</div>
                <div>状态：{infoObj?.stateToName}</div>
              </Space>
            </Col>
            <Col span={2}>
              {infoObj.state === '5' ? (
                <Button onClick={confirmGoods}>确认收货</Button>
              ) : null}
            </Col>
          </Row>
        </div>
      )}
      <CustomTable
        dataSource={
          orderType === 'returnorder'
            ? infoObj?.returnProductDTOList
            : infoObj?.cancelProductDTOList
        }
        isLoading={false}
        columns={orderType === 'returnorder' ? returnlistColumn : listColumn}
      ></CustomTable>
      <Modal
        title="提示"
        width={450}
        open={visible}
        onOk={okModal}
        onCancel={hideModal}
        okText="确定"
        cancelText="取消"
      >
        <Form form={form}>
          <Form.Item
            label="原因"
            name="reason"
            rules={[
              { required: true, whitespace: true, message: '请输入理由' },
            ]}
            {...itemLayou}
          >
            <Input.TextArea autoComplete="off" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default Cooperation
